import styled from 'styled-components';

export const Thead = styled.thead``;
